(() => {
  'use strict';
  const bar = document.querySelector('.orzo-concierge');
  if (!bar) return;
  const select = bar.querySelector('select');
  const venues = new Map([...select.options].filter(o => o.value).map(o => [o.value, o]));
  const key = 'orzo.preferredVenue';
  let stored = '';
  try { stored = localStorage.getItem(key) || ''; } catch (_) { /* Selection still works without storage. */ }
  const fromHash = () => location.hash.startsWith('#menu-') ? location.hash.slice(6) : '';
  // Generic calls to action follow the choice; explicit venue links keep their destination.
  const navLinks = [...document.querySelectorAll('a[href]')].filter(a => !a.closest('.orzo-concierge')).map(a => ({a, href:a.getAttribute('href')}));
  function setVenue(handle, remember = true) {
    const option = venues.get(handle);
    select.value = option ? handle : '';
    if (remember) { try { option ? localStorage.setItem(key, handle) : localStorage.removeItem(key); } catch (_) {} }
    const menu = '/pages/menu' + (option ? '#menu-' + handle : '');
    const book = option ? option.dataset.book : '/pages/rezerwacja';
    bar.style.setProperty('--concierge-color', option ? option.dataset.color : '#162e25');
    bar.querySelector('[data-concierge-menu]').href = menu;
    bar.querySelector('[data-concierge-book]').href = book;
    bar.querySelector('[data-concierge-map]').href = option ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent('ORZO ' + option.dataset.address) : '/pages/lokale';
    const phone = bar.querySelector('[data-concierge-phone]');
    phone.hidden = !option;
    if (option) phone.href = 'tel:' + option.dataset.phone;
    else phone.removeAttribute('href');
    navLinks.forEach(({a,href}) => {
      if (!href) return;
      const url = new URL(href, location.origin);
      const globalNavigation = !!a.closest('.bar,#drwnav,.fcols');
      if (url.origin === location.origin && url.pathname === '/pages/menu' && (!url.hash || globalNavigation)) {
        url.hash = option ? 'menu-' + handle : '';
        a.href = url.pathname + url.search + url.hash;
      }
      if ((url.origin === location.origin && url.pathname === '/pages/rezerwacja' && !url.hash && !url.search) || (a.classList.contains('rez') && globalNavigation && url.hostname === 'mojstolik.pl')) a.href = book;
    });
  }
  // Pamiętamy wyłącznie wybór, który gość zrobił świadomie — w tym pasku albo
  // na liście przy przycisku rezerwacji. Samo obejrzenie strony lokalu ustawia
  // kontekst na tej stronie, ale nie zostaje w pamięci przeglądarki: inaczej
  // gość z Warszawy po jednej wizycie na stronie Wrocławia rezerwował we Wrocławiu.
  const initial = [bar.dataset.currentVenue, fromHash(), stored].find(h => venues.has(h)) || '';
  setVenue(initial, false);
  select.addEventListener('change', () => {
    setVenue(select.value);
    if (document.querySelector('.menu-venue') && select.value) {
      location.hash = 'menu-' + select.value;
      const details = document.getElementById('menu-' + select.value);
      if (details) details.open = true;
    }
  });
  addEventListener('hashchange', () => { if (venues.has(fromHash())) setVenue(fromHash(), false); });
  document.querySelectorAll('.menu-venue').forEach(details => details.addEventListener('toggle', () => {
    if (details.open && venues.has(details.id.slice(5))) setVenue(details.id.slice(5), false);
  }));
  if (document.querySelector('.menu-venue') && !fromHash() && initial) {
    const details = document.getElementById('menu-' + initial);
    if (details) details.open = true;
  }
  bar.hidden = false;
  document.body.classList.add('has-concierge');
  const size = () => document.documentElement.style.setProperty('--concierge-height', bar.offsetHeight + 'px');
  size();
  if (window.ResizeObserver) new ResizeObserver(size).observe(bar);
})();
